import React from "react";
import DashboardLinksSection from "./DashboardLinksSection";
import {MenuSection} from "../../layout/menu/MenuItems";
import SlimContainer from "../../layout/SlimContainer";


type Props = {
    menuSections: MenuSection[],
};

const DashboardLinks = ({menuSections}: Props) => {
    return (
        <SlimContainer className={"my-12 lg:my-24 flex flex-col gap-12"}>
            {
                menuSections.map((section: MenuSection, i: number) => (
                    section.excludeInParentOverview
                        ? <React.Fragment key={i}/>
                        : <DashboardLinksSection key={i} {...section}/>
                ))
            }
        </SlimContainer>
    );
};

export default DashboardLinks;